import './components'
import '@fortawesome/fontawesome-free/css/all.css'
import '@mdi/font/css/materialdesignicons.css'

import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueRouter from 'vue-router'
import routes from './router'
import HttpService from './service/http.service'
import CacheServicePlugin, {CacheService} from './service/cache.service'
import VueCookies from 'vue-cookies'
import moment from "moment";
import SocketServicePlugin from './service/socket.service'
import Directives from './directives'
import vuetify from './plugins/vuetify'
import {MessagePlugin} from "./service/message.service";
import {SessionPlugin} from "./service/session.service";
import IdleVue from "idle-vue";
import {ProgressPlugin} from "./service/progress.service";
import localforage from "localforage";


Vue.config.productionTip = false
Vue.use(HttpService)
Vue.use(CacheServicePlugin)
Vue.use(VueRouter);
Vue.use(SocketServicePlugin)
Vue.use(Directives);
Vue.use(MessagePlugin)
Vue.use(SessionPlugin)
Vue.use(ProgressPlugin)

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 300000,
  startAtIdle: false
});

const router = new VueRouter({ routes });
router.beforeEach((to, from, next) => {
	let parents = to.matched.filter(r => r.path === '/menu')
	const accessToken = window.$cookies.get('access_token_ibk')
	if (parents[0]) {
		if (accessToken && parents[0]) {
			next()
		} else {
			window.$cookies.remove("access_token_ibk");
			window.$cookies.remove("refresh_token_ibk");
			window.$cookies.remove("idleTimeoutIbk");
			localforage.removeItem("userDetailIbk");
			
			next({ name: 'login' })
		}
	} else {
		next();
	}
})
Vue.filter('month', function (value) {
	return moment(value).locale("id").format("MM")
})
Vue.filter('year', function (value) {
	return moment(value).locale("id").format("YYYY")
})
Vue.filter('dateformat', function (value) {
	return moment(value).locale("id").format("DD-MM-YYYY")
})
Vue.filter('datetimeformat', function (value) {
	return moment(value).locale("id").format("DD-MM-YYYY HH:mm:ss")
})
Vue.filter('timeformat', function (value) {
	return moment(value).locale("id").format("HH:mm:ss")
})
Vue.filter('timeminuteformat', function (value) {
	return moment(value).locale("id").format("HH:mm")
})
Vue.filter('dayformat', function (value) {
	return moment(value).locale("id").format("dddd, DD MMMM YYYY")
})
Vue.filter('daywithtimeformat', function (value) {
	return moment(value).locale("id").format("dddd, DD MMMM YYYY HH:mm:ss")
})
Vue.filter('localdatetime', function (value) {
	return moment(value).locale("id").format("YYYY-MM-DDTHH:mm:ss")
})
Vue.filter('localdate', function (value) {
	return moment(value).locale("id").format("YYYY-MM-DD")
})
Vue.filter('formatter', function (value, parse, format) {
	return moment(value, parse).locale("id").format(format)
})
Vue.filter('decimalformat', function (value) {
	if (typeof value !== "number") {
		return value;
	}
	var formatter = new Intl.NumberFormat('en', {
		minimumFractionDigits: 2,
	});
	return formatter.format(value);
})
Vue.filter('persenformat', function (value) {
	if (!value) return '0'
	return parseFloat(value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'))
})
Vue.filter('accountformat', function (value) {
	if (!value) return ''
	if (value === '-') return '-'
	value = value.toString()
	return value.substring(0, 3) + "." + value.substring(3, 5) + "." + value.substring(5, value.length - 1) + "-" + value.substring(value.length - 1)
})
Vue.filter('accountformatext', function (value) {
	if (!value) return ''
	if (value === '-') return '-'
	value = value.toString();
	let valueSplit = value.split("-");
	if (valueSplit.length > 1) {
		let bank = valueSplit[0].trim();
		let account = valueSplit[1].trim();
		return "(" + bank + ") " + account.substring(0, 3) + "." + account.substring(3, 5) + "." + account.substring(5, account.length - 1) + "-" + account.substring(account.length - 1)
	}else{
		return value.substring(0, 3) + "." + value.substring(3, 5) + "." + value.substring(5, value.length - 1) + "-" + value.substring(value.length - 1)
	}
})
VueCookies.config('1d')

new Vue({
  router,
  store,
  vuetify,
  iconfont: 'mdi',
  render: h => h(App)
}).$mount('#app')
